import { useState } from "react";

import { IDE_TYPE } from "../model/ide.types";

export const useCodeJamLauncher = (isClubsDomain) => {
  const [isPickerOpen, setIsPickerOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [ideType, setIdeType] = useState(IDE_TYPE.TEXT_JAM);

  const openCodeJam = () => {
    if (isClubsDomain) {
      setIsPickerOpen(true);
    } else {
      setIdeType(IDE_TYPE.TEXT_JAM);
      setIsModalOpen(true);
    }
  };

  const selectIde = (nextIdeType) => {
    setIdeType(nextIdeType);
    setIsPickerOpen(false);
    setIsModalOpen(true);
  };

  const closePicker = () => setIsPickerOpen(false);
  const closeModal = () => setIsModalOpen(false);

  // "Previous Options" in the CodeJam modal: return to the editor picker.
  const backToPicker = () => {
    setIsModalOpen(false);
    setIsPickerOpen(true);
  };

  return {
    isPickerOpen,
    isModalOpen,
    ideType,
    openCodeJam,
    selectIde,
    closePicker,
    closeModal,
    backToPicker,
  };
};
